import { render, staticRenderFns } from "./PqHeader.vue?vue&type=template&id=6651ab64&scoped=true&"
import script from "./PqHeader.vue?vue&type=script&lang=js&"
export * from "./PqHeader.vue?vue&type=script&lang=js&"
import style0 from "./PqHeader.vue?vue&type=style&index=0&id=6651ab64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6651ab64",
  null
  
)

export default component.exports